import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PortalTotalTravelTimeNode } from '@app/services/api/api.types';

@Component({
  selector: 'nonstop-flight-badge',
  templateUrl: './nonstop-flight-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NonstopFlightBadgeComponent {
  @Input() travelTime: PortalTotalTravelTimeNode;
}
